{
  "currentActivity": "Attività attuale",
  "online": "online",
  "active": "attivi",
  "deviceMarkerUpdating": "Aggiornamento...",
  "doNotShowThisAgain": "Non mostrare più questo messaggio",
  "inFieldWithFieldName": "Nel campo ${{fieldName}}",
  "locateDevice": {
    "helpBody": "Per poter essere localizzato, un dispositivo deve essere acceso e avere ricezione cellulare.",
    "coordinatesWithLongitudeAndLatitude": "Coordinate: {{longitude}}, {{latitude}}",
    "copyLocation": "Copia",
    "goTo": "Vai a",
    "linkTo": "Individuare",
    "noLocationMessage": "Questo dispositivo non ha la posizione GPS. Assicurati che sia acceso e che abbia la ricezione cellulare",
    "noLocationTitle": "Nessuna posizione GPS",
    "openInApple": "Apri in Apple Maps",
    "openInGoogleMaps": "Apri in Google Maps",
    "title": "Posizione del dispositivo"
  },
  "locateDeviceCooordinatesLabel": "Coordinate",
  "locateField": {
    "appleMaps": "Vai a (Apple Maps)",
    "errorMessage": {
      "message": "Impossibile calcolare il centro del campo. Contattare l'assistenza.",
      "title": "Qualcosa è andato storto"
    },
    "googleMaps": "Vai a (Google Maps)"
  },
  "mapSettingsFieldColor": "Colore del campo",
  "mapSettingsMapTypeId": "Stile mappa",
  "mapSettingsTitle": "Impostazioni mappa",
  "quickActions": {
    "connectDevices": "Connetti dispositivi",
    "createField": "Nuovo campo",
    "manageSchedules": "Gestisci le pianificazioni",
    "mapSettings": "Impostazioni mappa",
    "newDevice": "Nuovo dispositivo",
    "title": "Azioni",
    "viewDeviceActivity": "Visualizza l'attività del dispositivo",
    "viewSchedules": "Visualizza gli orari"
  },
  "selectedDevice": {
    "commandsLink": "Controlli",
    "deviceProfileLink": "Maneggio",
    "notifications": "Notifiche"
  },
  "selectedReelRunTitle": "Corsa della bobina",
  "setReelDistance": {
    "distanceMmCurrent": {
      "errors": {
        "max": "Questo valore è troppo alto rispetto alla soglia consentita per gli override manuali della distanza"
      },
      "labelWithUnitLabel": "Distanza rimanente ({{unitLabel}})"
    },
    "distanceMmMax": {
      "labelWithUnitLabel": "Distanza estesa ({{unitLabel}})"
    },
    "errorMessage": "Al momento il nostro servizio non può elaborare la tua richiesta. Riprova.",
    "instructions": "Vuoi ignorare le distanze di corsa?",
    "linkTo": "Imposta distanza",
    "noActiveRunsMessage": "Non è stata trovata alcuna bobina attiva per questo dispositivo.",
    "noActiveRunsTitle": "Nessuna corsa attiva del rullo",
    "notRetractingMessage": "Impossibile impostare la distanza di una bobina che non si sta ritraendo.",
    "successMessage": "Modifiche salvate. Attendi un aggiornamento...",
    "title": "Imposta la distanza della bobina",
    "warning": "Questo non può essere annullato"
  },
  "setRunDirection": {
    "flipButton": "Capovolgere",
    "instructions": "Vuoi modificare la direzione della corsa?",
    "linkTo": "Imposta direzione",
    "title": "Imposta la direzione di esecuzione del rullo"
  },
  "setApplicationType": {
    "instructions": "Cosa ha applicato questo passaggio? Questo sostituisce il tipo di applicazione della configurazione del rotolone solo per questo passaggio.",
    "linkTo": "Imposta tipo di applicazione",
    "title": "Imposta tipo di applicazione del passaggio"
  },
  "setRunField": {
    "automaticOption": "Automatico (GPS)",
    "instructions": "Assegna questo passaggio a un campo. Automatico usa il punto finale GPS del passaggio; scegliere un campo fissa il passaggio a quel campo e usa la direzione delle file di quel campo.",
    "linkTo": "Imposta campo",
    "title": "Imposta campo del passaggio"
  },
  "manageReelRun": "Gestisci passaggio del rotolone",
  "deviceActivityHide": "Nascondi attività",
  "deviceActivityLabel": "Attività",
  "deviceActivityShow": "Mostra attività",
  "heatmapLayersHide": "Nascondi mappa termica",
  "heatmapLayersLabel": "Mappa termica",
  "heatmapLayersShow": "Mostra mappa termica",
  "heatmapLegendTitle": "Application Depth - Last 7 Days",
  "showDevices": "Dispositivi",
  "showFields": "Campi",
  "showReelRuns": "Rullo corre",
  "showTimeline": "Cronologia",
  "title": "Mappa dello stato",
  "unknownDevice": "Dispositivo sconosciuto",
  "unknownFields": {
    "description": "Le serie di rulli non saranno visibili a meno che non rientrino nei limiti di uno dei tuoi campi.",
    "dismissButton": "non adesso",
    "drawFieldButton": "Pulsante Disegna campo",
    "title": "Campi sconosciuti",
    "warningText": "FarmHQ ha ricevuto bobine di dati per i seguenti dispositivi in campi sconosciuti:"
  }
}
